import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PublishExamMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  password?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type PublishExamMutation = { __typename?: 'Mutation', publishExam?: { __typename?: 'PublishExamPayload', successful: boolean, validations?: { __typename?: 'ValidationsExamGeneral', general?: Array<{ __typename?: 'ValidationsMessage', message: string }> | null } | null, error?: { __typename?: 'MeasuredResponseError', name: string, code: number, message: string } | null } | null };

export const PublishExamDocument = gql`
    mutation PublishExam($id: Int!, $password: String) {
  publishExam(id: $id, password: $password) {
    successful
    validations {
      general {
        message
      }
    }
    error {
      name
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishExamGQL extends Apollo.Mutation<PublishExamMutation, PublishExamMutationVariables> {
    document = PublishExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }